module.exports = __webpack_public_path__ + "img/PDPA-5.12093735.png";